import { render } from "./Multimedia.vue?vue&type=template&id=cecaf7e8"
import script from "./Multimedia.vue?vue&type=script&lang=js"
export * from "./Multimedia.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__